// START_MODULE components_organisms_navbar_navbar_tsx
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep section tracking and logo state without hiding or fading the navigation.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import React, { useEffect, useState } from 'react';
import AnchorLinkExport from 'react-anchor-link-smooth-scroll';

import * as Styled from './styled';

const AnchorLink = (
  (AnchorLinkExport as unknown as { default?: typeof AnchorLinkExport }).default
  ?? AnchorLinkExport
) as typeof AnchorLinkExport;
import { AnchorLinkStyled, Logo } from './styled';
import { getActiveSection } from './helpers/getActiveSection';
import { getLinkTitle } from './helpers/getLinkTitle';

import logo from 'assets/logo.jpg';

import { Section } from 'routes/section';

const OFFSET_ANCHOR_LINK = 50;

const Navbar: React.FC = () => {
  const [initial, setInitial] = useState(true);
  const [activeSection, setActiveSection] = useState<Section | undefined>(Section.MAIN);

  useEffect(() => {
    const updateNavbar = () => {
      setInitial(window.scrollY < window.innerHeight * 0.5);
      setActiveSection(getActiveSection());
    };

    updateNavbar();
    window.addEventListener('scroll', updateNavbar, { passive: true });
    return () => window.removeEventListener('scroll', updateNavbar);
  }, []);

  return (
    <Styled.NavbarWrapper $initial={initial} style={{ zIndex: 12313 }}>
      {
        !initial && (
          <AnchorLink href={`#${Section.MAIN}`}>
            <Logo src={logo} />
          </AnchorLink>
        )
      }
      <ul>
        {
          Object.values(Section).slice(1).map((section) => (
            <AnchorLinkStyled href={`#${section}`} offset={OFFSET_ANCHOR_LINK} $active={section === activeSection} key={section}>
              <li>{getLinkTitle(section)}</li>
            </AnchorLinkStyled>
          ))
        }
      </ul>
    </Styled.NavbarWrapper>
  );
};

export default Navbar;

// END_MODULE components_organisms_navbar_navbar_tsx
